// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"5d5ba100","453":"0ecc119b"}[chunkId] + ".chunk.js";
};